module.exports = __webpack_public_path__ + "static/media/bordado.fcd12657.jpg";